import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import Button from '../Button';
import InputBox from '../Input/InputBox';
import { navigateSize } from '../system';

var SegmentedControl = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SegmentedControl, _Component);

  function SegmentedControl(_props) {
    var _this;

    _this = _Component.call(this, _props) || this;

    _defineProperty(_assertThisInitialized(_this), "getActiveIndex", function (props) {
      return props.activeSegment === undefined ? 0 : props.segments.indexOf(props.activeSegment);
    });

    _defineProperty(_assertThisInitialized(_this), "setInputBox", function (component) {
      _this.inputBox = component;
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      if (_this.props.onChange && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
        var amountToMove = event.key === 'ArrowLeft' ? -1 : 1;
        var nextIndex = _this.state.activeIndex + amountToMove;
        event.preventDefault();

        _this.changeSegment(nextIndex);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changeSegment", function (index) {
      var nextSegment = _this.props.segments[index];

      if (nextSegment) {
        if (_this.props.activeSegment === undefined) {
          _this.setState({
            activeIndex: index
          });
        }

        if (_this.props.onChange) {
          _this.props.onChange(nextSegment.title || nextSegment);
        }

        _this.focus(index);
      }
    });

    _this.state = {
      activeIndex: _this.getActiveIndex(_props)
    };
    return _this;
  }

  var _proto = SegmentedControl.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(lastProps) {
    if (lastProps.activeSegment !== this.props.activeSegment) {
      this.setState({
        activeIndex: this.getActiveIndex(this.props)
      });
    }
  };

  _proto.focus = function focus(index) {
    this.inputBox.focus(index);
  };

  _proto.blur = function blur() {
    this.inputBox.blur();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        activeSegment = _this$props.activeSegment,
        _this$props$color = _this$props.color,
        color = _this$props$color === void 0 ? 'primary' : _this$props$color,
        disabled = _this$props.disabled,
        onChange = _this$props.onChange,
        segments = _this$props.segments,
        _this$props$segmentBa = _this$props.segmentBasis,
        segmentBasis = _this$props$segmentBa === void 0 ? 'auto' : _this$props$segmentBa,
        _this$props$size = _this$props.size,
        size = _this$props$size === void 0 ? 'md' : _this$props$size,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["activeSegment", "color", "disabled", "onChange", "segments", "segmentBasis", "size"]);

    var activeIndex = this.state.activeIndex;
    return /*#__PURE__*/React.createElement(InputBox, _extends({
      ref: this.setInputBox,
      size: size,
      includeSpacing: true,
      evenPadding: true,
      role: "group",
      cursor: "initial",
      disabled: disabled
    }, restProps), segments.map(function (segment, segmentIndex) {
      var title = segment.title,
          restSegmentProps = _objectWithoutPropertiesLoose(segment, ["title"]);

      var buttonProps = title ? restSegmentProps : {};
      return /*#__PURE__*/React.createElement(Button, _extends({
        key: segmentIndex,
        grow: 1,
        size: navigateSize(size, -1),
        basis: segmentBasis,
        theme: segmentIndex === activeIndex ? color : undefined,
        variant: segmentIndex === activeIndex ? 'fill' : 'naked',
        title: title || segment,
        disabled: disabled,
        onKeyDown: _this2.handleKeyDown,
        onClick: function onClick() {
          return segmentIndex !== activeIndex && _this2.changeSegment(segmentIndex);
        }
      }, buttonProps));
    }));
  };

  return SegmentedControl;
}(Component);

export default SegmentedControl;